import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { updateDocumentTitle } from '../../actions/common';
import { NoRightsPage } from '../../components/NoRightsPage/NoRightsPage';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {
        updateDocumentTitle: (title: string) => dispatch(updateDocumentTitle(title))
    };
};

export const NoRightsPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(NoRightsPage);
